import { useEffect, useState, useRef } from 'react';
import { Box, MenuItem, Button, List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { isPathArrayActive } from '../../Utilities/HelperMethods';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import {
  NavMenu,
  navButtonStyles,
  navButtonActiveStyles,
  MobileMenuItemStyle,
} from './StyledComponents';
import { MobileNavButton } from './MobileNavButton';
import { NavButton } from './NavButton';

export const AdminMenuItem = ({
  Admin,
  AgencyManagement,
  MailRoom,
  InformationServices,
  ContentManagement,
  ISDMarketing,
  ManagerOnboardingAdmin,
  toggleDrawer,
}) => {
  const [open, setOpen] = useState(false);
  const isMedium = useMediaQuery('(max-width:1200px)');
  const isMobile = useMediaQuery('(max-width:600px)');
  const adminAnchorRef = useRef(null);
  const location = useLocation();
  const basePaths = ['/Admin', '/SupportStaff'];
  const isAdminPath = isPathArrayActive(location.pathname, basePaths);
  const [mobileOpen, setMobileOpen] = useState(isAdminPath ? true : false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleMobileToggle = () => {
    setMobileOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    handleClose();
  }, [location]);

  const renderAdminMenuItems = () => {
    return (
      <>
        {MailRoom && (
          <MenuItem
            sx={{ background: location.pathname.includes('/User') ? '#0000000a !important' : '' }}
            onClick={handleClose}
            component={NavLink}
            to="/Admin"
          >
            Mail Room
          </MenuItem>
        )}
        {(ContentManagement || ManagerOnboardingAdmin) && (
          <MenuItem
            sx={{
              background: location.pathname.includes('/ContentMgt') ? '#0000000a !important' : '',
            }}
            onClick={handleClose}
            component={NavLink}
            to="/Admin/ContentMgt"
          >
            Content Management
          </MenuItem>
        )}
        {ISDMarketing && (
          <MenuItem
            sx={{
              background: location.pathname.includes('/ISDMarketing') ? '#0000000a !important' : '',
            }}
            component={NavLink}
            to="/Admin/ISDMarketing"
          >
            ISD Marketing
          </MenuItem>
        )}
      </>
    );
  };

  const renderMenu = () => {
    if (isMedium || isMobile) {
      return (
        <List
          sx={{ width: '100%', bgcolor: 'background.paper', padding: '0px !important' }}
          component="nav"
        >
          <ListItemButton sx={MobileMenuItemStyle} onClick={handleMobileToggle}>
            <ListItemText primary="Admin" />
            {mobileOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={mobileOpen} timeout="auto">
            <List
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                borderLeft: '1px solid #2CA6FA',
                marginLeft: '1rem',
              }}
              disablePadding
            >
              {MailRoom && (
                <ListItemButton
                  sx={{
                    ...MobileMenuItemStyle,
                    pl: 4,
                    background: location.pathname.includes('/User') ? '#0000000a !important' : '',
                  }}
                  component={NavLink}
                  to="/Admin"
                  onClick={toggleDrawer}
                >
                  <ListItemText primary="Mail Room" />
                </ListItemButton>
              )}
              {(ContentManagement || ManagerOnboardingAdmin) && (
                <ListItemButton
                  sx={{
                    ...MobileMenuItemStyle,
                    pl: 4,
                    background: location.pathname.includes('/ContentMgt')
                      ? '#0000000a !important'
                      : '',
                  }}
                  component={NavLink}
                  to="/Admin/ContentMgt"
                  onClick={toggleDrawer}
                >
                  <ListItemText primary="Content Management" />
                </ListItemButton>
              )}
              {ISDMarketing && (
                <ListItemButton
                  sx={{
                    ...MobileMenuItemStyle,
                    pl: 4,
                    background: location.pathname.includes('/ISDMarketing')
                      ? '#0000000a !important'
                      : '',
                  }}
                  component={NavLink}
                  to="/Admin/ISDMarketing"
                  onClick={toggleDrawer}
                >
                  <ListItemText primary="ISD Marketing" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </List>
      );
    }

    return (
      <>
        <Button
          ref={adminAnchorRef}
          onClick={handleToggle}
          sx={{
            ...navButtonStyles,
            ...(isAdminPath && {
              ...navButtonActiveStyles,
            }),
          }}
        >
          Admin
        </Button>
        <NavMenu anchorEl={adminAnchorRef.current} open={open} onClose={handleClose}>
          {renderAdminMenuItems()}
        </NavMenu>
      </>
    );
  };

  const renderContent = () => {
    // System
    if (
      (Admin || MailRoom || InformationServices) &&
      !AgencyManagement &&
      !ContentManagement &&
      !ManagerOnboardingAdmin &&
      !ISDMarketing
    ) {
      if (isMedium || isMobile) {
        return (
          <MobileNavButton
            toggleDrawer={toggleDrawer}
            to="/Admin"
            label="Admin"
            location={location}
          />
        );
      }
      return (
        <NavButton
          sx={{ background: location.pathname.includes('/Admin') ? 'lightgrey' : '' }}
          to="/Admin"
          label="Admin"
          location={location}
        />
      );
    }

    // Agency
    if (
      AgencyManagement &&
      !Admin &&
      !MailRoom &&
      !InformationServices &&
      !ContentManagement &&
      !ManagerOnboardingAdmin &&
      !ISDMarketing
    ) {
      if (isMedium || isMobile) {
        return (
          <MobileNavButton
            toggleDrawer={toggleDrawer}
            to="/SupportStaff"
            label="Admin"
            location={location}
          />
        );
      }
      return (
        <NavButton
          sx={{ background: location.pathname.includes('/Admin') ? 'lightgrey' : '' }}
          to="/SupportStaff"
          label="Admin"
          location={location}
        />
      );
    }

    // Content Management Access
    if (
      !AgencyManagement &&
      !Admin &&
      !MailRoom &&
      !InformationServices &&
      !ISDMarketing &&
      (ContentManagement || ManagerOnboardingAdmin)
    ) {
      if (isMedium || isMobile) {
        return (
          <MobileNavButton
            toggleDrawer={toggleDrawer}
            to="/Admin/ContentMgt"
            label="Admin"
            location={location}
          />
        );
      }
      return (
        <NavButton
          sx={{ background: location.pathname.includes('/Admin/ContentMgt') ? 'lightgrey' : '' }}
          to="/Admin/ContentMgt"
          label="Admin"
          location={location}
        />
      );
    }

    // ISD Marketing
    if (
      !AgencyManagement &&
      !Admin &&
      !MailRoom &&
      !InformationServices &&
      !ContentManagement &&
      !ManagerOnboardingAdmin &&
      ISDMarketing
    ) {
      if (isMedium || isMobile) {
        return (
          <MobileNavButton
            toggleDrawer={toggleDrawer}
            to="/ISDMarketing"
            label="Admin"
            location={location}
          />
        );
      }
      return (
        <NavButton
          sx={{ background: location.pathname.includes('/Admin/ISDMarketing') ? 'lightgrey' : '' }}
          to="/ISDMarketing"
          label="Admin"
          location={location}
        />
      );
    }

    // Return nothing if no admin permissions
    if (
      !AgencyManagement &&
      !Admin &&
      !MailRoom &&
      !InformationServices &&
      !ContentManagement &&
      !ManagerOnboardingAdmin &&
      !ISDMarketing
    ) {
      return null;
    }

    // render menu if mulitple permissions
    return renderMenu();
  };

  return <Box sx={{ borderRadius: 'none' }}>{renderContent()}</Box>;
};
